import type { Job } from '@/domains/jobs/components/JobCard';
import type { JobPriority } from '@/shared/lib/priority';

export const GANTT_STATUS_COLORS: Record<Job['status'], string> = {
  pending: 'bg-slate-400 border-slate-500',
  'in-progress': 'bg-orange-500 border-orange-600',
  completed: 'bg-green-500 border-green-600',
  urgent: 'bg-red-500 border-red-600',
};

export const GANTT_PRIORITY_BORDERS: Record<JobPriority, string> = {
  critical: 'border-l-4 border-l-red-700',
  high: 'border-l-4 border-l-red-600',
  medium: 'border-l-4 border-l-yellow-600',
  low: 'border-l-4 border-l-blue-600',
  unknown: 'border-l-4 border-l-gray-400',
};
